export default __webpack_public_path__ + "static/media/701.a4a086ea.png";